import { render, staticRenderFns } from "./detail_users_admin_pague.vue?vue&type=template&id=835aa018&scoped=true"
import script from "./detail_users_admin_pague.vue?vue&type=script&lang=js"
export * from "./detail_users_admin_pague.vue?vue&type=script&lang=js"
import style0 from "./detail_users_admin_pague.vue?vue&type=style&index=0&id=835aa018&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835aa018",
  null
  
)

export default component.exports